var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _g, _path61, _path62, _path63, _path64, _path65, _g2, _path66, _path67, _path68, _g3, _path69, _path70, _path71, _g4, _path72, _path73, _path74, _g5, _path75, _path76, _path77, _g6, _path78, _path79, _path80, _g7, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLightbulb(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 214,
    height: 206,
    viewBox: "0 0 214 206",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M107.059 35.5203C107.059 35.0135 107.059 34.5068 107.036 34",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M107.036 50.6737C107.085 47.5617 107.105 44.4497 107.096 41.3378",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M107.036 58.9466V56.3098",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M129.078 39.6403C129.506 38.7298 129.934 37.8234 130.401 36.9293",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M122.915 53.7389C124.674 50.0721 126.155 46.2941 127.769 42.5696",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M119.436 61.5546C120.192 59.8516 120.948 58.1528 121.704 56.4581",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M116.303 58.9466L120.874 43.3112",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M90.0533 46.3435C91.6113 51.0238 92.9338 55.7907 94.5088 60.3968",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M87.0702 36.9293C87.7693 39.1267 88.4655 41.324 89.1588 43.5213",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M90.7339 60.1826L91.3759 61.5546",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M86.287 50.6736L89.5312 57.6075",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M68.0242 67.4132C69.6762 69.2507 71.3155 71.1006 72.9119 72.9876",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M60.6455 59.0126C62.3575 61.1014 64.1851 63.1326 65.9998 65.1596",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M57.2472 55.1479L58.5312 56.627",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M61.4886 67.1248L70.2327 75.2494",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M62.4174 93.8142L65.0795 94.4693",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M43.3757 89.1298L59.7211 93.1674",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M38.5178 87.9349L40.2855 88.3717",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M58.8607 88.4952L65.0796 91.2021",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M51.7987 85.4259L56.0787 87.2881",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M160.267 56.9649L161.332 56.1162",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M155.302 60.9284L157.784 58.9467",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M145.086 69.0777L152.832 62.8977",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M138.751 74.1288L142.74 70.9481",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M139.667 55.1479L131.052 66.581",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M173.817 81.4459L175.688 80.9021",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M156.406 86.5218C161.281 85.1498 166.173 83.8314 170.988 82.274",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M147.756 89.0679C149.622 88.4787 151.501 87.9225 153.385 87.3787",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M148.801 93.5917L164.722 91.5894",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M171.754 120.195L174.125 120.928",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M148.278 112.943C155.285 114.851 161.88 117.389 168.895 119.305",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M159.167 111.707L168.51 112.943",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M148.801 110.307L156.004 111.295",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M155.52 148.173L156.723 149.62",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M138.751 127.99C143.737 133.91 148.685 139.938 153.731 146.006",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M146.121 131.207C147.568 132.564 149.013 133.921 150.457 135.278",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M140.711 126.127L144.315 129.51",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M63.0936 148.396L62.1434 149.657",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M68.9572 140.667C67.6133 142.484 66.2522 144.292 64.8527 146.072",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M77.1663 129.807C74.945 132.555 72.8478 135.397 70.7463 138.24",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M69.4965 132.019L64.6216 136.238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M74.5384 127.656L71.658 130.148",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M49.509 122.102L43.8722 124.809",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M66.4663 113.973C61.938 116.128 56.9903 118.349 52.2139 120.812",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M65.0796 107.377L52.7446 109.45",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M143.181 80.9021L150.457 76.6296",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M76.627 59.7953L81.0653 66.5809",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M134.835 138.43L137.578 144.049",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M132.49 133.613C132.871 134.396 133.256 135.183 133.637 135.97",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M158.093 124.5L159.633 125.373",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M146.819 118.093L155.465 123.004",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M167.924 103.702H172.033",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M150.042 103.702C154.955 103.743 159.886 103.743 164.992 103.702",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M45.4943 103.879L38 103.999",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M60.0976 103.669C56.1386 103.747 52.1796 103.764 48.2163 103.813",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M64.6216 103.554L63.0209 103.603",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M57.4783 74.2648L51.3193 70.462",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M68.234 80.9021L60.1576 75.921",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M105.598 64.6566C85.5295 64.9285 69.2184 80.7699 69.0729 100.089C69.03 105.459 70.2498 110.768 72.6409 115.62C75.032 120.472 78.5325 124.74 82.8802 128.105C84.3971 129.301 85.5211 130.895 86.1158 132.694L87.8278 137.791H124.413L126.164 132.591C126.747 130.845 127.844 129.299 129.322 128.142C135.34 123.49 139.698 117.146 141.789 109.995C143.879 102.844 143.598 95.2432 140.985 88.2533C138.371 81.2635 133.556 75.2336 127.21 71.0056C120.865 66.7775 113.306 64.5622 105.59 64.669L105.598 64.6566Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_71_246",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 69,
    y: 64,
    width: 75,
    height: 74
  }, _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M105.598 64.6566C85.5295 64.9285 69.2184 80.7699 69.0729 100.089C69.03 105.459 70.2498 110.768 72.6409 115.62C75.032 120.472 78.5325 124.74 82.8802 128.105C84.3971 129.301 85.5211 130.895 86.1158 132.694L87.8278 137.791H124.413L126.164 132.591C126.747 130.845 127.844 129.299 129.322 128.142C135.34 123.49 139.698 117.146 141.789 109.995C143.879 102.844 143.598 95.2432 140.985 88.2533C138.371 81.2635 133.556 75.2336 127.21 71.0056C120.865 66.7775 113.306 64.5622 105.59 64.669L105.598 64.6566Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_71_246)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M97.1112 134.841C97.1331 135.735 97.1112 136.242 97.1112 136.242",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.2124 123.927C96.6704 127.165 96.9015 130.127 97.017 132.336",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.9124 105.82H90.3102C93.0023 109.746 94.6287 115.156 95.6131 120.33",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.0913 104.794L97.7874 105.82H93.7899",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.95 107.707L100.604 108.835L98.6049 103.055L98.2882 104.122",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.08 106.343L104.289 108.835L102.367 103.055L101.335 106.442",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.692 105.688L109.891 103.055L107.97 108.835L106.129 103.055L105.59 104.748",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.652 105.82H114.467L113.653 103.055L111.65 108.835L111.021 106.763",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.206 117.66C118.216 113.347 119.714 109.07 121.944 105.82H116.893",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.114 123.391C116.32 122.003 116.572 120.565 116.872 119.123",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.374 130.189C115.481 128.739 115.635 127.103 115.853 125.357",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.194 133.3C115.194 132.921 115.233 132.509 115.254 132.064",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.13 136.242C115.13 136.242 115.13 135.566 115.157 134.4",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M105.598 64.6566C85.5295 64.9285 69.2184 80.7699 69.0729 100.089C69.03 105.459 70.2498 110.768 72.6409 115.62C75.032 120.472 78.5325 124.74 82.8802 128.105C84.3971 129.301 85.5211 130.895 86.1158 132.694L87.8278 137.791H124.413L126.164 132.591C126.747 130.845 127.844 129.299 129.322 128.142C135.34 123.49 139.698 117.146 141.789 109.995C143.879 102.844 143.598 95.2432 140.985 88.2533C138.371 81.2635 133.556 75.2336 127.21 71.0056C120.865 66.7775 113.306 64.5622 105.59 64.669L105.598 64.6566ZM106.129 123.037C100.518 123.038 95.0325 121.437 90.3667 118.436C85.7009 115.436 82.0643 111.171 79.9168 106.181C77.7693 101.191 77.2074 95.6994 78.3022 90.4018C79.397 85.1041 82.0993 80.2381 86.0673 76.419C90.0353 72.5999 95.0907 69.9994 100.594 68.9463C106.098 67.8932 111.802 68.4349 116.986 70.5029C122.169 72.5709 126.599 76.0722 129.716 80.5641C132.832 85.0559 134.494 90.3365 134.493 95.7379C134.492 102.978 131.503 109.922 126.184 115.042C120.865 120.161 113.651 123.037 106.129 123.037Z",
    fill: "#92E3A9"
  }))), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M105.598 64.6566C85.5295 64.9285 69.2184 80.7699 69.0729 100.089C69.03 105.459 70.2498 110.768 72.6409 115.62C75.032 120.472 78.5325 124.74 82.8802 128.105C84.3971 129.301 85.5211 130.895 86.1158 132.694L87.8278 137.791H124.413L126.164 132.591C126.747 130.845 127.844 129.299 129.322 128.142C135.34 123.49 139.698 117.146 141.789 109.995C143.879 102.844 143.598 95.2432 140.985 88.2533C138.371 81.2635 133.556 75.2336 127.21 71.0056C120.865 66.7775 113.306 64.5622 105.59 64.669L105.598 64.6566Z",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M110.413 172.069H101.853C101.641 172.069 101.433 172.015 101.249 171.913C101.066 171.81 100.914 171.662 100.809 171.484L99.5251 169.309L94.5731 166.544H117.741L112.793 169.309L111.509 171.484C111.399 171.668 111.239 171.82 111.046 171.924C110.853 172.027 110.634 172.077 110.413 172.069Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M119.992 164.904H92.2662C92.7572 165.89 93.5275 166.723 94.4883 167.306C95.4492 167.889 96.5617 168.199 97.6976 168.2H114.556C115.693 168.199 116.806 167.889 117.767 167.306C118.729 166.723 119.5 165.89 119.992 164.904Z",
    fill: "#757575",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M119.992 164.904H92.2662L88.9663 142.286H123.292L119.992 164.904Z",
    fill: "#999999"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_71_246",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 88,
    y: 142,
    width: 36,
    height: 23
  }, _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M119.992 164.904H92.2662L88.9663 142.286H123.292L119.992 164.904Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_71_246)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M93.6873 157.464L93.9911 160.055L118.477 158.23L118.789 155.544L93.6873 157.464Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M102.911 164.13H115.686C116.098 164.129 116.502 164.024 116.858 163.825C117.215 163.626 117.51 163.34 117.715 162.997L102.911 164.13Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M94.1195 161.155L94.2308 162.123C94.3024 162.709 94.6097 163.245 95.0868 163.615L118.058 161.901L118.361 159.301L94.1195 161.155Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M119.346 150.793L119.44 149.978H105.911H105.354H92.8184L93.1394 152.75L119.346 150.793Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M93.2677 153.85L93.563 156.36L118.918 154.468L119.217 151.869L93.2677 153.85Z",
    fill: "white"
  }))), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M119.992 164.904H92.2662L88.9663 142.286H123.292L119.992 164.904Z",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M90.2973 153.504C90.0351 153.514 89.7798 153.422 89.5876 153.25C89.3953 153.078 89.2819 152.84 89.2723 152.588C89.2626 152.335 89.3575 152.09 89.5361 151.904C89.7147 151.719 89.9624 151.61 90.2246 151.601L121.897 149.347C122.158 149.329 122.417 149.411 122.615 149.576C122.814 149.741 122.937 149.975 122.956 150.227C122.975 150.479 122.89 150.728 122.718 150.919C122.547 151.11 122.304 151.228 122.042 151.247L90.3701 153.5L90.2973 153.504Z",
    fill: "#BFBFBF"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_71_246",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 89,
    y: 149,
    width: 34,
    height: 5
  }, _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M90.2973 153.504C90.0351 153.514 89.7798 153.422 89.5876 153.25C89.3953 153.078 89.2819 152.84 89.2723 152.588C89.2626 152.335 89.3575 152.09 89.5361 151.904C89.7147 151.719 89.9624 151.61 90.2246 151.601L121.897 149.347C122.158 149.329 122.417 149.411 122.615 149.576C122.814 149.741 122.937 149.975 122.956 150.227C122.975 150.479 122.89 150.728 122.718 150.919C122.547 151.11 122.304 151.228 122.042 151.247L90.3701 153.5L90.2973 153.504Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_71_246)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M122.83 149.858C122.753 150.002 122.639 150.124 122.499 150.213C122.359 150.302 122.197 150.354 122.029 150.365L90.3573 152.619H90.2846C90.1977 152.666 90.0997 152.692 89.9997 152.693C89.8998 152.694 89.8011 152.671 89.713 152.626C89.6249 152.58 89.5502 152.514 89.496 152.433C89.4417 152.352 89.4097 152.26 89.4029 152.164C89.396 152.068 89.4146 151.971 89.4569 151.884C89.4992 151.797 89.5638 151.722 89.6446 151.665C89.7254 151.608 89.8199 151.572 89.9191 151.56C90.0183 151.549 90.119 151.561 90.2118 151.597L121.884 149.343C122.077 149.33 122.269 149.372 122.437 149.464C122.605 149.555 122.742 149.693 122.83 149.858Z",
    fill: "white"
  })))), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M90.2973 153.504C90.0351 153.514 89.7798 153.422 89.5876 153.25C89.3953 153.078 89.2819 152.84 89.2723 152.588C89.2626 152.335 89.3575 152.09 89.5361 151.904C89.7147 151.719 89.9624 151.61 90.2246 151.601L121.897 149.347C122.158 149.329 122.417 149.411 122.615 149.576C122.814 149.741 122.937 149.975 122.956 150.227C122.975 150.479 122.89 150.728 122.718 150.919C122.547 151.11 122.304 151.228 122.042 151.247L90.3701 153.5L90.2973 153.504Z",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M90.8624 157.179C90.6002 157.189 90.3449 157.097 90.1526 156.926C89.9604 156.754 89.847 156.515 89.8373 156.263C89.8277 156.01 89.9226 155.765 90.1012 155.58C90.2798 155.395 90.5274 155.285 90.7896 155.276L121.366 153.097C121.628 153.078 121.886 153.16 122.085 153.325C122.284 153.49 122.406 153.724 122.425 153.976C122.445 154.228 122.359 154.477 122.188 154.668C122.016 154.859 121.773 154.977 121.511 154.996L90.9352 157.175L90.8624 157.179Z",
    fill: "#BFBFBF"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_71_246",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 89,
    y: 153,
    width: 34,
    height: 5
  }, _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M90.8624 157.179C90.6002 157.189 90.3449 157.097 90.1526 156.926C89.9604 156.754 89.847 156.515 89.8373 156.263C89.8277 156.01 89.9226 155.765 90.1012 155.58C90.2798 155.395 90.5274 155.285 90.7896 155.276L121.366 153.097C121.628 153.078 121.886 153.16 122.085 153.325C122.284 153.49 122.406 153.724 122.425 153.976C122.445 154.228 122.359 154.477 122.188 154.668C122.016 154.859 121.773 154.977 121.511 154.996L90.9352 157.175L90.8624 157.179Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_71_246)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M122.29 153.607C122.214 153.751 122.1 153.873 121.96 153.962C121.819 154.051 121.658 154.103 121.49 154.114L90.9138 156.302H90.8624C90.7756 156.349 90.6776 156.375 90.5776 156.376C90.4777 156.378 90.379 156.354 90.2909 156.309C90.2028 156.263 90.1281 156.197 90.0739 156.116C90.0196 156.035 89.9876 155.943 89.9808 155.847C89.9739 155.751 89.9925 155.655 90.0348 155.567C90.0771 155.48 90.1416 155.405 90.2225 155.348C90.3033 155.291 90.3978 155.256 90.497 155.244C90.5962 155.232 90.6969 155.244 90.7897 155.28L121.366 153.101C121.554 153.092 121.741 153.136 121.904 153.225C122.068 153.315 122.202 153.447 122.29 153.607Z",
    fill: "white"
  })))), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M90.8624 157.179C90.6002 157.189 90.3449 157.097 90.1526 156.926C89.9604 156.754 89.847 156.515 89.8373 156.263C89.8277 156.01 89.9226 155.765 90.1012 155.58C90.2798 155.395 90.5274 155.285 90.7896 155.276L121.366 153.097C121.628 153.078 121.886 153.16 122.085 153.325C122.284 153.49 122.406 153.724 122.425 153.976C122.445 154.228 122.359 154.477 122.188 154.668C122.016 154.859 121.773 154.977 121.511 154.996L90.9352 157.175L90.8624 157.179Z",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M91.3802 160.855C91.118 160.863 90.8629 160.771 90.6711 160.599C90.4792 160.427 90.3664 160.188 90.3573 159.936C90.3482 159.683 90.4437 159.438 90.6226 159.253C90.8016 159.068 91.0495 158.96 91.3117 158.951L120.801 156.854C120.93 156.845 121.061 156.86 121.184 156.9C121.307 156.939 121.421 157.001 121.52 157.083C121.618 157.164 121.699 157.264 121.757 157.376C121.816 157.487 121.851 157.609 121.86 157.734C121.87 157.858 121.854 157.984 121.813 158.102C121.772 158.221 121.708 158.331 121.623 158.426C121.538 158.52 121.434 158.598 121.318 158.654C121.202 158.71 121.076 158.744 120.946 158.753L91.4572 160.855H91.3802Z",
    fill: "#BFBFBF"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_71_246",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 90,
    y: 156,
    width: 32,
    height: 5
  }, _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M91.3802 160.855C91.118 160.863 90.8629 160.771 90.6711 160.599C90.4792 160.427 90.3664 160.188 90.3573 159.936C90.3482 159.683 90.4437 159.438 90.6226 159.253C90.8016 159.068 91.0495 158.96 91.3117 158.951L120.801 156.854C120.93 156.845 121.061 156.86 121.184 156.9C121.307 156.939 121.421 157.001 121.52 157.083C121.618 157.164 121.699 157.264 121.757 157.376C121.816 157.487 121.851 157.609 121.86 157.734C121.87 157.858 121.854 157.984 121.813 158.102C121.772 158.221 121.708 158.331 121.623 158.426C121.538 158.52 121.434 158.598 121.318 158.654C121.202 158.71 121.076 158.744 120.946 158.753L91.4572 160.855H91.3802Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_71_246)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M121.747 157.365C121.671 157.51 121.558 157.633 121.417 157.722C121.277 157.811 121.114 157.862 120.946 157.872L91.4572 159.973H91.3802C91.2933 160.02 91.1955 160.045 91.096 160.045C90.9964 160.046 90.8983 160.022 90.8108 159.976C90.7233 159.931 90.6491 159.865 90.5953 159.784C90.5415 159.703 90.5097 159.611 90.503 159.515C90.4962 159.42 90.5146 159.324 90.5565 159.237C90.5985 159.15 90.6626 159.075 90.7428 159.018C90.8231 158.962 90.9169 158.925 91.0156 158.913C91.1144 158.9 91.2147 158.912 91.3074 158.947L120.797 156.85C120.99 156.837 121.183 156.879 121.352 156.97C121.521 157.062 121.658 157.199 121.747 157.365Z",
    fill: "white"
  })))), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M91.3802 160.855C91.118 160.863 90.8629 160.771 90.6711 160.599C90.4792 160.427 90.3664 160.188 90.3573 159.936C90.3482 159.683 90.4437 159.438 90.6226 159.253C90.8016 159.068 91.0495 158.96 91.3117 158.951L120.801 156.854C120.93 156.845 121.061 156.86 121.184 156.9C121.307 156.939 121.421 157.001 121.52 157.083C121.618 157.164 121.699 157.264 121.757 157.376C121.816 157.487 121.851 157.609 121.86 157.734C121.87 157.858 121.854 157.984 121.813 158.102C121.772 158.221 121.708 158.331 121.623 158.426C121.538 158.52 121.434 158.598 121.318 158.654C121.202 158.71 121.076 158.744 120.946 158.753L91.4572 160.855H91.3802Z",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M91.9238 164.542C91.6616 164.551 91.4063 164.46 91.214 164.288C91.0218 164.116 90.9084 163.878 90.8987 163.625C90.8891 163.373 90.984 163.127 91.1626 162.942C91.3412 162.757 91.5888 162.648 91.851 162.638L120.257 160.615C120.519 160.597 120.778 160.679 120.976 160.844C121.175 161.009 121.297 161.243 121.317 161.495C121.336 161.747 121.251 161.996 121.079 162.187C120.908 162.378 120.665 162.496 120.403 162.515L91.9966 164.542H91.9238Z",
    fill: "#BFBFBF"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_71_246",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 90,
    y: 160,
    width: 32,
    height: 5
  }, _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M91.9238 164.542C91.6616 164.551 91.4063 164.46 91.214 164.288C91.0218 164.116 90.9084 163.878 90.8987 163.625C90.8891 163.373 90.984 163.127 91.1626 162.942C91.3412 162.757 91.5888 162.648 91.851 162.638L120.257 160.615C120.519 160.597 120.778 160.679 120.976 160.844C121.175 161.009 121.297 161.243 121.317 161.495C121.336 161.747 121.251 161.996 121.079 162.187C120.908 162.378 120.665 162.496 120.403 162.515L91.9966 164.542H91.9238Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_71_246)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M121.208 161.114C121.131 161.258 121.017 161.381 120.877 161.47C120.737 161.56 120.575 161.613 120.407 161.625L91.9966 163.648H91.9238C91.837 163.696 91.739 163.721 91.639 163.722C91.5391 163.724 91.4404 163.7 91.3523 163.655C91.2642 163.61 91.1895 163.543 91.1353 163.462C91.081 163.382 91.049 163.289 91.0422 163.193C91.0353 163.097 91.0539 163.001 91.0962 162.913C91.1385 162.826 91.203 162.751 91.2839 162.694C91.3647 162.638 91.4592 162.602 91.5584 162.59C91.6576 162.578 91.7583 162.59 91.8511 162.626L120.257 160.603C120.45 160.59 120.643 160.631 120.812 160.722C120.98 160.813 121.118 160.949 121.208 161.114Z",
    fill: "white"
  })))), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M91.9238 164.542C91.6616 164.551 91.4063 164.46 91.214 164.288C91.0218 164.116 90.9084 163.878 90.8987 163.625C90.8891 163.373 90.984 163.127 91.1626 162.942C91.3412 162.757 91.5888 162.648 91.851 162.638L120.257 160.615C120.519 160.597 120.778 160.679 120.976 160.844C121.175 161.009 121.297 161.243 121.317 161.495C121.336 161.747 121.251 161.996 121.079 162.187C120.908 162.378 120.665 162.496 120.403 162.515L91.9966 164.542H91.9238Z",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M127.118 135.15L126.031 146.826L123.489 148.672H88.7695L86.2229 146.826L85.14 135.15L85.8933 133.3H126.361L127.118 135.15Z",
    fill: "#92E3A9"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_71_246",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 85,
    y: 133,
    width: 43,
    height: 16
  }, _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M127.118 135.15L126.031 146.826L123.489 148.672H88.7695L86.2229 146.826L85.14 135.15L85.8933 133.3H126.361L127.118 135.15Z",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_71_246)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M126.031 146.826L123.489 148.672H88.7695L86.2229 146.826H126.031Z",
    fill: "black",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M127.118 135.15H85.14L85.8933 133.3H126.361L127.118 135.15Z",
    fill: "white"
  }))), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M127.118 135.15L126.031 146.826L123.489 148.672H88.7695L86.2229 146.826L85.14 135.15L85.8933 133.3H126.361L127.118 135.15Z",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M85.14 135.15H100.685",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M103.125 135.15H107.036",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M109.823 135.15H110.692",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M127.118 135.15H123.292",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M126.031 146.826H110.692",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M108.171 146.826H103.125",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M99.2084 146.826H98.1641",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M86.2228 146.826H90.3915",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M97.2096 165.452C98.652 166.73 102.102 167.632 106.129 167.632C110.157 167.632 113.602 166.73 115.049 165.452H97.2096Z",
    fill: "white"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M107.982 171.546H104.259C104.13 171.545 104.004 171.504 103.9 171.43C103.797 171.356 103.72 171.252 103.681 171.134L103.159 169.589H109.095L108.573 171.134C108.534 171.255 108.456 171.36 108.349 171.435C108.243 171.509 108.114 171.548 107.982 171.546Z",
    fill: "white"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M103.159 168.992H109.095L109.759 168.505H102.5L103.159 168.992Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightbulb);
export default __webpack_public_path__ + "static/media/Light bulb.b01884b24dff80c20003a51c2b02b13b.svg";
export { ForwardRef as ReactComponent };